import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=4bb30ada&scoped=true&"
import script from "./BannerSwiper.vue?vue&type=script&lang=js&"
export * from "./BannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&id=4bb30ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb30ada",
  null
  
)

export default component.exports